export default __webpack_public_path__ + "static/media/cloudysun.837a8efa.gif";